module.exports = __webpack_public_path__ + "img/product-kredit-pemilikan-rumah.c893d920.jpeg";